/**
 * 题目表单
 * @description 题目新增、编辑
 * @author mll
 * @date 2020-1-22
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Form, InputNumber, message, Radio, Upload} from 'antd'
import { component_tool,framework_tool } from '@/tool'
import {WizClassifySelectRe} from "@/containers/common"
import WizCourseContent from './GainLossRuleComp'
import ChoiceForm from './choiceForm'
let { WizAvatarUpload,ossFileUtils } = framework_tool
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizInputNumber,
    WizIcon,
    WizSwitch,
    WizDatePicker,
    WizRow,
    WizCol,
    WizCard,
    WizRadio,
    WizDivider,
    WizCheckbox,
  WizTreeSelectList
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

const scoreRuleBaseStr = '最多添加10个规则，每个规则最多添加20个关键词，每个关键词最多50字，支持中文、数字、字母及常见字符，按回车键可添加一个关键词；'
const scoreRuleGainStr = '所有得分规则的得分权重总和必须等于100'
const scoreRuleLossStr = '所有失分规则的得分权重总和必须等于100'

class SubjectForm extends Component {

    constructor(props) {
        super(props);
      let { mode } = props
        this.state = {
            type: mode && mode == 1 ? 'Script' : 'Subjective',
            answerSize: 0,
            modalVisible: false,
            img: ''
        }
        this.answerSize = 0;
        this.isStart = true;
        this.clearContentBack = []
    }
    _propInfo(nextProps, nextState) {
        let { propInfo, treeData, form } = nextProps
        if (propInfo && this.isStart) {
            if (propInfo.isStart) {
                if (propInfo['type']) {
                    nextState.type = propInfo['type']
                }
                if (propInfo.img) {
                    nextState.img = propInfo.img
                }
                if (propInfo.answer) {
                    form.answer = propInfo.answer
                    if (propInfo.type === "Completion") {
                        this.changeCompletionDefault(propInfo)
                        nextState.answerSize = propInfo.answerSize
                    } else {
                        nextState.answerSize = propInfo.options?.length
                    }
                }
                this.isStart = false
            }
        }

        return true
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this._propInfo(nextProps, nextState);
    }
    /**
     * foreach options
     * @param {*} options
     */
    _renderOptions(options) {
        if (options && options.length) {
            let { rowKey, rowName } = this.props
            //return null
            return options.map((row, i) => this._renderOption(row))
        }
        return null
    }

    /**
     * WizSelect.Option
     * @param {*} row
     * @param {*} rowKey
     * @param {*} rowName
     * @param {*} i
     */
    _renderOption(row) {
        if (row) {
            return (
                <Option key={row['key']} value={row['value']}>
                    {row['title']}
                </Option>
            )
        }
    }

    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    /**
     * 表单基础内容
     */
    _base() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo, treeData, treeSelectList,selects, mode } = this.props;
        let disabled = mode == 1 ? true : false

        let TreeSelectList = treeSelectList
        return [
            /**
             * 题目分类
             */
            //hasFeedback去除校验标识
          !disabled ? <Item label="题目分类" >
                {getFieldDecorator('classify', {
                    initialValue: propInfo.classify,
                    rules: [
                        { required: true, message: '请选择题目分类', type: 'array' },
                    ],
                })(
                  <WizClassifySelectRe
                    returnKey={true}
                    apiPath={'questionType/normalNodeList'}
                    apiProps={{type: 2, state: 1}}
                    initSelects={selects ? selects : []}
                    wizTreeSelectListProps={{
                      item: {
                        icon: 'unordered-list',
                        title: '题目分类',
                        tips: '请勾选所属题目分类'
                      },
                      multiple: true,
                      treeCheckable: false,
                      checkable: true,
                      showSelectList: true,
                      treeProps: {checkStrictly: true}
                    }}

                  />
                    // <TreeSelectList ref={(r) => this.treeSelectListRef = r && r.getWrappedInstance()} form={this.props.form} selects={this.props.selects} type='2' />
                )}
            </Item>: undefined,
            /**
             * 题目类型
             */
            <Item label="题目类型" >
                {getFieldDecorator('type', {
                    initialValue: !propInfo.type && mode == 1 ? "Script" : propInfo.type,
                    rules: [{ required: true, message: '请选择题目类型' }],
                })(
                    <WizSelect
                      disabled={disabled}
                        placeholder="请选择题目类型"
                        onChange={this._changeType}
                    >
                        <Option value="Single">单选题</Option>
                        <Option value="Multiple">多选题</Option>
                        <Option value="Judgement">判断题</Option>
                        <Option value="Completion">填空题</Option>
                      {disabled ? <Option value="Script">话术题</Option> :
                        <Option value="Subjective">主观题</Option>}
                    </WizSelect>,
                )}
            </Item>,
            <Item label="题目图片"
                key={this.state.img}
                label={
                    <span>
                        题目图片&nbsp;
                        <WizTooltip title="请上传大小不超过1MB">
                            <WizIcon type="question-circle-o" />
                        </WizTooltip>
                    </span>
                }>
                {getFieldDecorator('questionImg', {
                    initialValue: (propInfo && propInfo.img) ? [
                        {
                            fileId:propInfo.img,
                        }
                    ] : [],
                })(
                    <WizAvatarUpload
                        accept={'.jpg, .jpeg, .png'}
                        listType={'picture-card'}
                        aspectRatio={640 / 360}
                        beforeUpload={(file) => {
                            const isLt1M = file.size / 1024 / 1024 < 1;
                            if (!isLt1M) {
                                message.error('图片不得超过1MB!');
                            }
                            return isLt1M;
                        }}
                    />
                )}

            </Item>,
            /**
             * 题目编码
             */
            <Item label="题目编码" >
                {getFieldDecorator('code', {
                    initialValue: propInfo.code,
                    rules: [{ required: true, message: '请输入题目编码', whitespace: true }],
                })(<WizInput maxLength={50}  placeholder='请输入题目编码' />)}
            </Item>,
            /**
             * 题目
             */
            <Item label="题目" >
                {getFieldDecorator('subject', {
                    initialValue: propInfo.subject,
                    rules: [{ required: true, message: '请输入题目内容', whitespace: true }],
                })(<WizInput.TextArea maxLength={200} placeholder='请输入题目内容,最多200字' />)}
            </Item>,

            /**
             * 难度级别
             */
            <Item label="难度级别">
                {getFieldDecorator('difficulty', {
                    initialValue: propInfo.difficulty ? propInfo.difficulty : 'low'
                })(
                    <WizSelect placeholder="请选择难度级别">
                        <Option value="low">低</Option>
                        <Option value="middle">中</Option>
                        <Option value="high">高</Option>
                    </WizSelect>,
                )}
            </Item>,
          disabled ? <Item label="题目分值">
            {getFieldDecorator('score', {
              initialValue: propInfo.score,
              rules: [{ required: true, message: '请填写题目分值' }],
            })(
              <WizInputNumber style={{width: '100%'}} placeholder="请填写题目分值" min={0} max={999} precision={0}/>
            )}
          </Item> : undefined,
          disabled ? <Item label="题目合格线">
            {getFieldDecorator('passScore', {
              initialValue: propInfo.passScore,
              rules: [{ required: true, message: '请填写题目题目合格线' }],
            })(
              <WizInputNumber style={{width: '100%'}} placeholder="请填写题目题目合格线" min={0} max={999} precision={0}/>
            )}
          </Item> : undefined,
        ]
    }

    /**
     * 根据题目类型渲染不同的Form
     * 单选 Single, 多选 Multiple, 判断 Judgement, 填空 Completion, 主观 Subjective
     */
    _subject() {
        let { type } = this.state
        if (type === 'Single' || type === 'Multiple') {
            return this._select()
        } else if (type === 'Judgement') {
            return this._judgement()
        } else if (type === 'Completion') {
            return this._completion()
        } else if (type === 'Subjective') {
            return this._subjective()
        } else if (type === 'Script') {
          return this._script()
        } else {
            return []
        }
    }

    /**
     * 设置单选/多选的选项
     */
    changeOptions = data => {
        const { form } = this.props;
        this.setState({
            answerSize: data.length
        }, () => {
            form.setFieldsValue({
                options: data
            });
        })
    }

    /**
     * 单选/多选
     */
    _select() {
        const { type } = this.state
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        let choiceFormProps = {}
        if (propInfo && propInfo.options && propInfo.options.length) {
            choiceFormProps['dataSource'] = [...propInfo.options]
        }
        return [
            <Item label="选择设置" key={type}>
                {getFieldDecorator('options', {
                    initialValue: propInfo.options
                })(
                    <ChoiceForm
                        ref={(r) => { this.choiceFormRef = r }}
                        key={propInfo ? propInfo.choiceFormKey : 0}
                        getDataSource={this.changeOptions}
                        {...choiceFormProps}
                    />
                )}
            </Item>,
            <div>{this._selectAnswer()}</div>
        ]
    }

    /**
     * 选择题的答案区域
     */
    _selectAnswer() {
        const { setFieldsValue } = this.props.form
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        const { answerSize, type } = this.state;
        let Com = type === 'Single' ? WizRadio : WizCheckbox
        let answer = propInfo.type === type ? propInfo.answer : undefined
        let opt = []
        if (answerSize <= 0) {
            return
        } else {
            for (let i = 0; i < answerSize; i++) {
                opt.push(<Com value={i}>{String.fromCharCode(i + 65)}</Com>)
            }
            if (this.answerSize !== answerSize) {
                setFieldsValue({
                    answer: this.props.form.answer
                })
                this.answerSize = answerSize;
            } else {

            }
            return (
                <Item label="答案设置" key={type}>
                    {getFieldDecorator('answer', {
                        initialValue: answer,
                        rules: [
                            { required: true, message: '请选择正确答案' },
                        ],
                    })(
                        <Com.Group>
                            {opt}
                        </Com.Group>,
                    )}
                </Item>
            )
        }
    }

    /**
     * 判断
     */
    _judgement() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        return [
            <Item label="答案设置">
                {getFieldDecorator('answer', {
                    initialValue: propInfo.answer,
                    rules: [
                        { required: true, message: '请选择正确答案' },
                        { pattern: /^(1)|(0)$/, message: '请选择正确答案' },
                    ],
                })(
                    <WizRadio.Group>
                        <WizRadio value={0}>正确</WizRadio>
                        <WizRadio value={1}>错误</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>
        ]
    }

    /**
    * 填空题减少选项
    */
    remove = (k, key, idkey, answerKey) => {
        const { form } = this.props;
        const keys = form.getFieldValue(key);
        if (keys.length === 1 && answerKey === 'answer[0]') {
            return;
        }
        let _keys = keys.filter(e => e !== k);
        if (_keys.length) {
            for (let i = 0; i < _keys.length; i++) {
                let _key = _keys[i];
                form.setFieldsValue(
                    { [answerKey + `[${i}]`]: form.getFieldValue(answerKey + `[${_key}]`) }
                )
            }
        }
        let nextKeys = []
        for (let i = 0; i < keys.length - 1; i++) {
            nextKeys.push(i)
        }
        form.setFieldsValue({
            [key]: nextKeys
        });
        this[idkey]--
        if (this[idkey] === 0) {
            this.changeAllAnswer()
        }

    };

    /**
     * 填空题：当备选答案没有时整理所有答案的顺序，并且删除没有备选答案的答案区域
     */
    changeAllAnswer() {
        let { form } = this.props;
        let { answerSize } = this.state;
        let changeAnswer = (i) => {
            let completionAnswer = 'completionAnswer' + i;
            let nextCompletionAnswer = 'completionAnswer' + (i + 1);
            if (this[completionAnswer] === 0 && this[nextCompletionAnswer] > 0) {
                form.setFieldsValue({
                    ['keys' + i]: form.getFieldValue('keys' + (i + 1)),
                    ['answer' + i]: form.getFieldValue('answer' + (i + 1))
                })
                this[completionAnswer] = this[nextCompletionAnswer]
                this[nextCompletionAnswer] = 0
            }
        }
        for (let i = 0; i < answerSize; i++) {
            changeAnswer(i)
        }
        this.setState({ answerSize: --answerSize })
    }

    /**
     * 填空题增加选项
     */
    add = (key, idkey) => {
        const { form } = this.props;
        const keys = form.getFieldValue(key);
        let nextKeys = []
        if (keys) {
            for (let i = 0; i < keys.length; i++) {
                nextKeys.push(i)
            }
        }
        nextKeys = nextKeys.concat(this[idkey]++);
        form.setFieldsValue({
            [key]: nextKeys,
        });
    };

    /**
     * 填空
     */
    _completion() {
        let { answerSize } = this.state;
        const { getFieldDecorator } = this.props.form;
        const { form, propInfo } = this.props;
        let completion = {}
        if (propInfo) {
            if (propInfo.answer) {
                completion = propInfo.answer
            }
        }

        let r = []
        //答案内容的循环
        for (let i = 0; i < answerSize; i++) {
            let completionAnswerKey = 'completionAnswer' + i;
            if (this[completionAnswerKey] === undefined) {
                this[completionAnswerKey] = 0
            }
            r.push(this._completionAnswer(completion, 'keys' + i, 'answer' + i, completionAnswerKey, i))
        }
        //添加答案的按钮
        r.push(this._addCompletionAnswer())
        return r;
    }

    /**
     * 添加填空答案
     */
    _addCompletionAnswer() {
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 15, push: 6 },
                sm: { span: 15, push: 6 },
            },
        };
        return (
            <Item {...formItemLayoutWithOutLabel}>
                <WizButton type="dashed" onClick={() => {
                    let size = this.state.answerSize;
                    this[`completionAnswer${size}`] = 0
                    this.setState({ answerSize: ++size })
                }} style={{ width: '60%' }}>
                    <WizIcon type="plus" /> 增加答案
                </WizButton>
            </Item>
        )
    }

    /**
     * 填空答案及添加备选答案
     */
    _completionAnswer(completion, keys, answerKey, idKey, index) {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 15, push: 6 },
                sm: { span: 15, push: 6 },
            },
        };
        getFieldDecorator(keys, { initialValue: completion[keys] });
        const _keys = getFieldValue(keys);
        const divider = (
            <WizDivider>
                答案{index + 1}
            </WizDivider>
        )
        const formItems = _keys && _keys.map((k, index) => (
            <Item
                label={index === 0 ? '答案' : '备选答案' + (index + 1)}
                required={false}
                key={k}
            >
                {getFieldDecorator(answerKey + `[${k}]`, {

                    initialValue: (completion[answerKey]) ? completion[answerKey][k] : '',
                    validateTrigger: ['onChange', 'onBlur'],
                    rules: [
                        {
                            required: true,
                            whitespace: true,
                            message: "请输入答案或删除此答案",
                        },
                    ],
                })(
                    <WizInput placeholder="请输入答案" style={{ width: '60%', marginRight: 8 }} />)}
                {answerKey === 'answer0' && _keys.length === 1 ? null : (
                    <WizIcon
                        key={k}
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        onClick={() => this.remove(k, keys, idKey, answerKey)}
                    />
                )}
            </Item>
        ));
        let add = this[idKey] === 5 ? null : (
            <Item {...formItemLayoutWithOutLabel}>
                <WizButton type="dashed" onClick={() => { this.add(keys, idKey) }} style={{ width: '60%' }}>
                    <WizIcon type="plus" /> 增加备选答案
                </WizButton>
            </Item>
        )
        return [
            <>{divider}</>,
            <>{formItems}</>,
            <>{add}</>
        ]
    }

    /**
     * 主观
     */
    _subjective() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        let initialValue = '';
        if (propInfo['type'] === 'Subjective') {
            initialValue = propInfo.answer ||''
        }
        return [
            <Item label="正确答案" >
                {getFieldDecorator('answer', {
                    initialValue,
                  rules: [
                    // { required: true, message: '请输入正确答案' }
                  ],
                })(
                    <WizInput.TextArea maxLength={200} placeholder='请输入正确,最多200字' />
                )}
            </Item>
        ]
    }

  /**
   * 话术
   */
  _script() {
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
    const { propInfo } = this.props;
    if (propInfo['type'] === 'Script') {
      propInfo.cmdListGet = propInfo.gainList
      propInfo.cmdListLoss = propInfo.lossList
    }

    const scoreRuleGainView = getFieldDecorator('scoreRuleGain', {
      initialValue: propInfo?.scoreRuleGain,
      trigger: 'onBlur',
      rules: [
        {required: getFieldValue('scoreRuleGain') > 0, message: '请输入正整数'}
      ],
    })(<InputNumber disabled={!(getFieldValue('scoreRuleGain') > 0)} precision={0} min={1}/>)

    return [
      <Item label="标准答案" >
        {getFieldDecorator('answer', {
          initialValue: propInfo.answer || '',
          rules: [{ required: true, message: '请输入标准答案', whitespace: true }],
        })(
          <WizInput.TextArea maxLength={2000} placeholder='请输入正确,最多2000字' />
        )}
      </Item>,
      <Item label="评分方式">
        {getFieldDecorator('scoreWay', {
          initialValue: propInfo.scoreWay ? propInfo.scoreWay : '0'
        })(
          <WizSelect placeholder="请选择评分方式" disabled>
            <Option value="0">系统</Option>
          </WizSelect>,
        )}
      </Item>,
      <Item label="答题方式">
        {getFieldDecorator('answerWay', {
          initialValue: propInfo.answerWay ? propInfo.answerWay : 0,
        })(
          <WizRadio.Group>
            <WizRadio value={0}>语音</WizRadio>
            <WizRadio value={1}>文字</WizRadio>
          </WizRadio.Group>,
        )}
      </Item>,
      <Item label="评分方式">
        {getFieldDecorator('mateWay', {
          initialValue: propInfo.mateWay ? propInfo.mateWay : 3,
          rules: [{ required: true, message: '请选择评分方式' }],
        })(
          <WizSelect disabled={true} placeholder="请选择评分方式">
            <Option value={0}>精准匹配</Option>
            {/* <Option value={1}>相似度匹配</Option> */}
            {/* <Option value={2}>近义词匹配</Option> */}
            <Option value={3}>模型评分</Option>
          </WizSelect>,
        )}
      </Item>,
      <Item label={<span>得分规则&nbsp;<WizTooltip title={scoreRuleBaseStr+scoreRuleGainStr}><WizIcon type="question-circle-o" /></WizTooltip></span>}>
        <WizButton type="primary" onClick={() => this._ref_scoreRuleGain?.handleMenuClick?.()}>
          添加规则
        </WizButton>
        {
          getFieldValue('mateWay') == 3 ?
            <Item label={'分值规则'} required={false}>
              <Radio.Group
                value={getFieldValue('scoreRuleGain') > 0}
                onChange={e => {setFieldsValue({scoreRuleGain: !!e.target.value ? getFieldValue('scoreRuleGain') || 1 : undefined })}}
              >
                <Radio value={false}>权重规则计算</Radio>
                <Radio value={true}>
                  得分规则计算&nbsp;{scoreRuleGainView}
                </Radio>
              </Radio.Group>
            </Item> : undefined
        }
        {getFieldDecorator('cmdListGet', {
          initialValue: propInfo.cmdListGet ? propInfo.cmdListGet : [],
          rules: [
            {
              required: true,
              message: '请添加得分规则',
            },
            {
              validator: (rule, value, callback) => {
                value.forEach(item => {
                  if (Number(item.ratio) && Number(item.ratio) <= 0) {
                    callback('得分权重请输入正整数')
                  }
                })
                callback();
              }
            }

          ],
        })(
          <WizCourseContent wrappedComponentRef={r => this._ref_scoreRuleGain = r && r.getWrappedInstance()} type={0} hiddenAddBtn={true} mateWay={getFieldValue('mateWay')} scoreRule={getFieldValue('scoreRuleGain') > 0 ? 1 : 0} onClearContent={this._onClearContent.bind(this)} />
        )}
      </Item>,
    ]
  }

  _onReset = (f) => {
    // let ref = this.refs.form
    // if (ref) {
    //   ref.resetFields()
    // }
    console.log('_onReset')

    this.clearContentBack.forEach(callback => {
      callback && callback()
    })
  }

  _onClearContent(callback) {
    if (callback) {
      this.clearContentBack.push(callback)
    }
  }

    /**
     * 题目解析部分
     */
    _analysis() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        return (
            <Item label="解析" >
                {getFieldDecorator('analysis', { initialValue: propInfo.analysis })(
                    <WizInput.TextArea maxLength={200} placeholder='请输入解析,最多200字' />
                )}
            </Item>
        )
    }

    /**
     * 修改题目状态
     */
    _changeType = (type) => {
        const { propInfo } = this.props;
        //类型和初始类型不同时(修改题目类型)将form中的答案设为null
        if (propInfo['type'] !== type) {
            this.props.form.setFieldsValue({
                answer: null
            });
        }
        if (type === 'Completion' || type === 'Single' || type === 'Multiple') {
            this.setState({
                type,
                answerSize: 0
            })
            this.answerSize = 0
            this.changeSelectDefault(type)
            if (type === 'Completion') {
                this.changeCompletionDefault(propInfo)
            }
        } else {
            this.setState({ type })
        }

    }

    /**
     * 表单提交按钮
     */
    _submit() {
        return (
            <Item wrapperCol={{ span: 12, offset: 6 }}>
                <WizRow>
                    <WizCol span={24} style={{ textAlign: 'center' }}>
                        <WizButton type="primary" onClick={this.handleSubmit}>
                            保存
                        </WizButton>
                        <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                            重置
                        </WizButton>
                    </WizCol>
                </WizRow>
            </Item>
        )
    }

    /**
     * 处理表单提交事件
     */
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['validity'] = values['validity'] && values['validity'].format('YYYY-MM-DD')
                let questionImg = values['questionImg']
                if (questionImg && questionImg.length) {
                    values['img'] = questionImg[0]['fileId']
                    delete values['questionImg']
                }
                let { submit } = this.props
                submit && submit(values)
            }
        });
    };

    /**
     * 重置表单
     */
    handleReset = () => {
        let { selects, propInfo } = this.props;
        //重置表单时初始化数据源
        this.isStart = true;
        //初始化题目分类的回调
        this.treeSelectListRef && this.treeSelectListRef._wizSelectOnChange(this.props.selects)
        //多选或者单选时格式化选项
        this.changeSelectDefault()
        //填空题重置
        this.changeCompletionDefault(propInfo)
        this._onReset()
        //重置表单
        this.props.form.resetFields();
    };


    /**
     * 填空题重置
     */
    changeCompletionDefault = (propInfo) => {
        if (propInfo && propInfo['type'] === 'Completion') {
            let answer = propInfo['answer']
            for (let key in answer) {
                if (key.indexOf('answer') !== -1) {
                    let value = answer[key]
                    let index = key.split('answer')[1];
                    this['completionAnswer' + index] = value.length
                }
            }
            this.setState({ answerSize: propInfo['answerSize'] })
            this.answerSize = propInfo['answerSize']
        } else {
            for (let key in this) {
                if (key.indexOf('completionAnswer') !== -1) {
                    this[key] = 0
                }
            }
            this.answerSize = 0
            this.setState({ answerSize: 0 })
        }
    }

    /**
     * 修改选择题的默认值
     */
    changeSelectDefault = (type) => {
        let { propInfo } = this.props;
        if (!propInfo || !propInfo['type']) {
            if (type === 'Multiple' || type === 'Single' || !type) {
                this.choiceFormRef && this.choiceFormRef['_setState']({
                    dataSource: [{
                        key: 0,
                        name: '',
                        img: '',
                        order: 1
                    }]
                })
            }
        } else {
            if (propInfo['type'] === 'Multiple' || propInfo['type'] === 'Single') {
                let options = propInfo['options']
                if (options && options.length) {
                    for (let index = 0; index < options.length; index++) {
                        options[index]['key'] = index
                        options[index]['order'] = index + 1
                    }
                }
                this.choiceFormRef && this.choiceFormRef['_setState']({ dataSource: options })
            }
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { title } = this.props;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (
            <WizCard>
                <WizForm
                    {...formItemLayout}
                    onSubmit={() => { return false }}
                >
                    {this._base()}
                    {this._subject()}
                    {this._analysis()}
                    {this._submit()}
                </WizForm>
            </WizCard>
        )

    }
}

export default WizForm.create()(SubjectForm);

/**
 * 默认值
 */
SubjectForm.defaultProps = {
    title: '新增题目',
    propInfo: {},
    selects: [],
    mode: 0,
}

/**
 * props入参校验
 */
SubjectForm.propTypes = {
    title: PropTypes.string.isRequired,//卡片标题
    submit: PropTypes.fun,//提交的回调方法
    propInfo: PropTypes.object,//Info信息
    treeSelectList: PropTypes.node,//分类树组件
    treeData: PropTypes.array,//treeData
    selects: PropTypes.array,
    mode: PropTypes.number,
}
